
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <div className="relative py-16 md:py-24 overflow-hidden">
      {/* Background gradients */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-1/3 w-96 h-96 rounded-full bg-primary/10 blur-3xl"></div>
        <div className="absolute bottom-0 right-1/3 w-96 h-96 rounded-full bg-accent/10 blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6">
            Discover & Share Powerful 
            <span className="text-primary"> Automation Workflows</span>
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-3xl mx-auto">
            The marketplace for no-code automation templates. Buy, sell, and download ready-to-use workflows for Zapier, Make.com, n8n and more.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            <Link to="/marketplace">
              <Button size="lg" className="px-8">
                Browse Workflows
              </Button>
            </Link>
            <Link to="/sell">
              <Button size="lg" variant="outline" className="px-8">
                Sell Your Workflows
              </Button>
            </Link>
          </div>
        </div>

        {/* Mock interface */}
        <div className="mt-8 md:mt-16 max-w-5xl mx-auto">
          <div className="rounded-xl overflow-hidden shadow-2xl border border-border">
            <div className="bg-secondary p-4 border-b border-border flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-destructive"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
              <div className="w-3 h-3 rounded-full bg-green-400"></div>
              <div className="ml-4 text-xs text-muted-foreground">Workflow Marketplace</div>
            </div>
            <div className="bg-card p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="bg-background rounded-lg p-4 shadow-sm border border-border hover-scale">
                  <div className="h-40 bg-secondary rounded mb-4 flex items-center justify-center p-4">
                    <div className="w-full h-full bg-primary/10 rounded flex items-center justify-center">
                      <p className="text-primary font-medium">Workflow Preview</p>
                    </div>
                  </div>
                  <h3 className="font-medium mb-2">Automated Customer Onboarding</h3>
                  <div className="flex items-center text-xs text-muted-foreground mb-3">
                    <span className="bg-secondary px-2 py-1 rounded">Zapier</span>
                    <span className="mx-2">•</span>
                    <span>Sales</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="font-medium">$24.99</div>
                    <Button variant="outline" size="sm">View Details</Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trusted by section */}
        <div className="mt-16 md:mt-24 text-center">
          <p className="text-sm uppercase text-muted-foreground tracking-wider mb-6">
            Trusted by automation experts from
          </p>
          <div className="flex flex-wrap justify-center gap-8 md:gap-16">
            {["Zapier", "Make.com", "n8n", "Airtable", "Notion"].map((brand) => (
              <div 
                key={brand} 
                className="text-muted-foreground/60 font-semibold text-lg md:text-xl"
              >
                {brand}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
